import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Canvas, useThree } from "@react-three/fiber";
import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { Euler, PerspectiveCamera, Vector3, VSMShadowMap } from "three";
import { CAMERA_PRESETS, LIGHTING_PRESETS } from "../util/ThreeJSPresets";
export const GameCanvas = ({ children, cameraPreset, lightingPreset }) => {
    const measurementDivRef = useRef(null);
    const camera = useMemo(() => {
        const { fov, aspect, near, far, } = CAMERA_PRESETS[cameraPreset].cameraOption;
        const camera = new PerspectiveCamera(fov, aspect, near, far);
        camera.position.set(0, 6, 13);
        camera.setRotationFromEuler(new Euler(CAMERA_PRESETS[cameraPreset].cameraXRotation, 0, 0));
        return camera;
    }, [cameraPreset]);
    const { color, intensity, hemisphereLightIntensity, } = LIGHTING_PRESETS[lightingPreset];
    const directionalLight = useMemo(() => {
        return _jsx("directionalLight", { castShadow: true, position: new Vector3(-1, 2, 4), color: color, intensity: intensity, "shadow-camera-near": 0.5, "shadow-camera-far": 100, "shadow-camera-left": -20, "shadow-camera-bottom": -20, "shadow-camera-right": 20, "shadow-camera-top": 20, "shadow-mapSize": [2048, 2048] });
    }, [lightingPreset]);
    return (_jsx("div", { ref: measurementDivRef, style: {
            width: '100%', height: '100%'
        }, children: _jsxs(Canvas, { gl: { antialias: true, powerPreference: 'high-performance' }, shadows: { enabled: true, type: VSMShadowMap, autoUpdate: false }, camera: camera, children: [_jsx(Scale, { measurementDivRef: measurementDivRef }), directionalLight, _jsx("hemisphereLight", { color: 0xffffff, groundColor: 0xffffff, intensity: hemisphereLightIntensity }), children] }) }));
};
const Scale = ({ measurementDivRef }) => {
    const state = useThree();
    const [setSize] = useState(() => state.setSize);
    const [dimensions, setDimensions] = useState(undefined);
    useLayoutEffect(() => {
        if (measurementDivRef.current) {
            const observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    setDimensions({
                        width: entry.contentRect.width,
                        height: entry.contentRect.height,
                    });
                }
            });
            observer.observe(measurementDivRef.current);
            // Cleanup function
            return () => {
                observer.disconnect();
            };
        }
    }, [measurementDivRef]);
    useLayoutEffect(() => {
        if (dimensions === undefined) {
            return;
        }
        const { width, height } = dimensions;
        setSize(width, height);
        state.set({ setSize: () => null });
        return () => {
            state.set({ setSize });
        };
    }, [setSize, dimensions]);
    return null;
};
//# sourceMappingURL=GameCanvas.js.map